import { apiRequest } from '../../api/client.js';
import type { TaxInvoiceDoc } from '../../../../shared/contracts/tax-invoice.js';

/** The tax invoice the system made for a bill, as it is shown and printed. */
export function loadBillDocument(claimId: string, token: string | null): Promise<TaxInvoiceDoc> {
  return apiRequest<TaxInvoiceDoc>(`/v1/billing/invoices/claim/${claimId}/document`, { token });
}
